module.exports = __webpack_public_path__ + "img/swap-box-fill.fc3dd0e6.svg";